import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './pages/Home';
import Company from './pages/Company';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Tokutei from './pages/Tokutei';
import ChildSafety from './pages/ChildSafety';
import NoticeCompanyChange from './pages/NoticeCompanyChange';
import './styles/global.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/company" element={<Company />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/tokutei" element={<Tokutei />} />
          <Route path="/childsafety" element={<ChildSafety />} />
          <Route path="/news/company-change" element={<NoticeCompanyChange />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
